var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "gift-form" } },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "ruleForm",
          staticClass: "demo-ruleForm",
          attrs: {
            model: _vm.ruleForm,
            rules: _vm.rules,
            "label-width": "120px",
            size: "small",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "礼包名称", prop: "name" } },
            [
              _vm.typeStr === "details"
                ? _c("p", [_vm._v(_vm._s(_vm.ruleForm.name))])
                : _c("el-input", {
                    attrs: { maxlength: "30", "show-word-limit": "" },
                    model: {
                      value: _vm.ruleForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "name", $$v)
                      },
                      expression: "ruleForm.name",
                    },
                  }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "礼包简称", prop: "shortName" } },
            [
              _vm.typeStr === "details"
                ? _c("p", [_vm._v(_vm._s(_vm.ruleForm.shortName))])
                : _c("el-input", {
                    attrs: { maxlength: "8", "show-word-limit": "" },
                    model: {
                      value: _vm.ruleForm.shortName,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "shortName", $$v)
                      },
                      expression: "ruleForm.shortName",
                    },
                  }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "商品", prop: "goodsList" } },
            [
              _vm.ruleForm.goodsList.length !== 0
                ? [
                    _vm._l(_vm.ruleForm.goodsList, function (it, index) {
                      return [
                        _vm.typeStr === "details"
                          ? _c("p", [
                              _vm._v(
                                _vm._s(it.goodsSkuName) + " * " + _vm._s(it.num)
                              ),
                            ])
                          : _c(
                              "p",
                              [
                                _c("span", { staticClass: "goods-sku-name" }, [
                                  _vm._v(_vm._s(it.goodsSkuName)),
                                ]),
                                _c("el-input-number", {
                                  attrs: {
                                    min: 1,
                                    size: "mini",
                                    label: "描述文字",
                                  },
                                  model: {
                                    value: _vm.ruleForm.goodsList[index].num,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.ruleForm.goodsList[index],
                                        "num",
                                        $$v
                                      )
                                    },
                                    expression: "ruleForm.goodsList[index].num",
                                  },
                                }),
                                _c(
                                  "el-link",
                                  {
                                    attrs: { type: "danger" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteGoods(it.goodsSkuId)
                                      },
                                    },
                                  },
                                  [_c("i", { staticClass: "el-icon-delete" })]
                                ),
                              ],
                              1
                            ),
                      ]
                    }),
                  ]
                : _vm._e(),
              _vm.typeStr !== "details"
                ? _c(
                    "el-link",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.showDialog },
                    },
                    [_vm._v("新增"), _c("i", { staticClass: "el-icon-plus" })]
                  )
                : _vm._e(),
            ],
            2
          ),
          _c(
            "el-form-item",
            { attrs: { label: "礼包包含类目", prop: "categoryNo" } },
            [
              _c(
                "el-select",
                {
                  attrs: { multiple: "", disabled: "" },
                  model: {
                    value: _vm.ruleForm.categoryNo,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "categoryNo", $$v)
                    },
                    expression: "ruleForm.categoryNo",
                  },
                },
                _vm._l(_vm.firstCategory, function (item) {
                  return _c("el-option", {
                    key: "dd" + item.categoryNo,
                    attrs: { label: item.categoryName, value: item.categoryNo },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "images",
              attrs: {
                label: "轮播图（" + _vm.ruleForm.images.length + "/5）",
                prop: "images",
              },
            },
            [
              _c("upload-picture", {
                class: [
                  {
                    "images-list":
                      _vm.ruleForm.images && _vm.ruleForm.images.length > 4,
                  },
                  { details: _vm.rQuery.type === "details" },
                ],
                attrs: { limitNumber: 5, "file-list": _vm.ruleForm.images },
                on: {
                  getUrl: _vm.getImagesUrl,
                  handleRemove: _vm.removeImagesUrl,
                },
              }),
              _c("p", [
                _vm._v(
                  "建议上传1125*330px图片，每张上传大小不得超过2M,支持jpg、png格式"
                ),
              ]),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "detail-image",
              attrs: { label: "详情", prop: "detailImage" },
            },
            [
              _c("upload-picture", {
                class: [
                  {
                    "detail-image-list":
                      _vm.ruleForm.detailImage &&
                      _vm.ruleForm.detailImage.length !== 0,
                  },
                  { details: _vm.rQuery.type === "details" },
                ],
                attrs: {
                  limitNumber: 5,
                  "file-list": _vm.ruleForm.detailImage,
                },
                on: {
                  getUrl: _vm.getDetailsUrl,
                  handleRemove: _vm.removeDetailsUrl,
                },
              }),
              _c("p", [_vm._v("每张上传大小不得超过5M,支持jpg、png格式")]),
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "price", attrs: { label: "价格", prop: "price" } },
            [
              _vm.typeStr === "details"
                ? _c("p", [_vm._v(_vm._s(_vm.ruleForm.price) + "元")])
                : [
                    _c("el-input", {
                      staticClass: "pure-number",
                      on: {
                        input: function ($event) {
                          _vm.ruleForm.price = _vm.checkValue(
                            _vm.ruleForm.price,
                            2
                          )
                        },
                      },
                      model: {
                        value: _vm.ruleForm.price,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "price", $$v)
                        },
                        expression: "ruleForm.price",
                      },
                    }),
                    _vm._v("元 "),
                  ],
            ],
            2
          ),
          _c(
            "el-form-item",
            {
              staticClass: "price",
              attrs: { label: "赠送积分", prop: "points" },
            },
            [
              _vm.typeStr === "details"
                ? _c("p", [_vm._v(_vm._s(_vm.ruleForm.points))])
                : _c("el-input", {
                    staticClass: "pure-number",
                    on: {
                      input: function ($event) {
                        _vm.ruleForm.points = _vm.checkValue(
                          _vm.ruleForm.points,
                          0
                        )
                      },
                    },
                    model: {
                      value: _vm.ruleForm.points,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "points", $$v)
                      },
                      expression: "ruleForm.points",
                    },
                  }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "佣金", prop: "commission" } },
            [
              _vm.typeStr === "details"
                ? _vm._l(_vm.ruleForm.commission, function (it, index) {
                    return _c("p", [
                      _vm._v(
                        "推荐第" +
                          _vm._s(index + 1) +
                          "个次" +
                          _vm._s(_vm.ruleForm.commission[index]) +
                          "%，将获得" +
                          _vm._s(
                            _vm.calcProfit(
                              _vm.ruleForm.commission[index],
                              _vm.ruleForm.price
                            )
                          ) +
                          "元收益"
                      ),
                    ])
                  })
                : _vm._l(_vm.ruleForm.commission, function (it, index) {
                    return _c(
                      "p",
                      [
                        _vm._v("推荐第" + _vm._s(index + 1) + "个次"),
                        _c("el-input", {
                          staticClass: "pure-number",
                          attrs: { size: "mini" },
                          on: {
                            input: function ($event) {
                              _vm.ruleForm.commission[index] = _vm.checkValue(
                                _vm.ruleForm.commission[index],
                                2
                              )
                            },
                          },
                          model: {
                            value: _vm.ruleForm.commission[index],
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm.commission, index, $$v)
                            },
                            expression: "ruleForm.commission[index]",
                          },
                        }),
                        _vm._v(
                          "%，将获得 " +
                            _vm._s(
                              _vm.calcProfit(
                                _vm.ruleForm.commission[index],
                                _vm.ruleForm.price
                              )
                            ) +
                            " 元收益"
                        ),
                      ],
                      1
                    )
                  }),
              _c(
                "p",
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: { disabled: _vm.typeStr === "details" },
                      model: {
                        value: _vm.ruleForm.selfCommissionFlag,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "selfCommissionFlag", $$v)
                        },
                        expression: "ruleForm.selfCommissionFlag",
                      },
                    },
                    [_vm._v("个人购买第1次后自己购买佣金归自己 ")]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "el-form-item",
            { attrs: { label: "礼包支付方式", prop: "payTypeList" } },
            [
              _c(
                "el-checkbox-group",
                {
                  model: {
                    value: _vm.ruleForm.payTypeList,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "payTypeList", $$v)
                    },
                    expression: "ruleForm.payTypeList",
                  },
                },
                _vm._l(
                  _vm.dictionaries.gift_package_pay_type,
                  function (it, index) {
                    return _c("el-checkbox", {
                      attrs: {
                        label: it.dictName,
                        name: "type",
                        disabled: index !== 0 || _vm.typeStr === "details",
                      },
                    })
                  }
                ),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "标签", prop: "tagList", required: "" } },
            [
              _c(
                "div",
                {
                  staticClass: "labelbox",
                  staticStyle: { "flex-wrap": "wrap" },
                },
                [
                  _vm._l(_vm.seletedTag, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: "dd" + item.id,
                        staticClass: "labelitem",
                        staticStyle: { "margin-bottom": "10px" },
                      },
                      [
                        _vm._v(" " + _vm._s(item.tagName) + " "),
                        _vm.typeStr !== "details"
                          ? _c("i", {
                              staticClass: "el-icon-circle-close labelicon",
                              on: {
                                click: function ($event) {
                                  return _vm.deleteTag(index)
                                },
                              },
                            })
                          : _vm._e(),
                      ]
                    )
                  }),
                  _vm.typeStr !== "details"
                    ? _c(
                        "el-button",
                        {
                          staticStyle: { "margin-bottom": "10px" },
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.dialogVisible = true
                            },
                          },
                        },
                        [_vm._v("添加标签")]
                      )
                    : _vm._e(),
                ],
                2
              ),
            ]
          ),
          _c(
            "el-form-item",
            { attrs: { label: "平台", prop: "platformIds" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    multiple: "",
                    disabled: _vm.typeStr === "details",
                    placeholder: "请选择平台",
                  },
                  model: {
                    value: _vm.ruleForm.platformIds,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "platformIds", $$v)
                    },
                    expression: "ruleForm.platformIds",
                  },
                },
                _vm._l(_vm.platformListFilter, function (item) {
                  return _c("el-option", {
                    key: "dd" + item.id,
                    attrs: { label: item.name, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "sales", attrs: { label: "库存", prop: "stock" } },
            [
              _vm.typeStr === "details"
                ? _c("p", [_vm._v(_vm._s(_vm.ruleForm.stock))])
                : _c("el-input", {
                    staticClass: "pure-number",
                    attrs: {
                      oninput: "value=value.replace(/^(0+)|[^\\d]+/g,'')",
                    },
                    model: {
                      value: _vm.ruleForm.stock,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "stock", $$v)
                      },
                      expression: "ruleForm.stock",
                    },
                  }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "sales",
              attrs: { label: "销量", prop: "fakeSaleNum" },
            },
            [
              _vm.typeStr === "details"
                ? _c("p", [_vm._v(_vm._s(_vm.ruleForm.fakeSaleNum))])
                : _c("el-input", {
                    staticClass: "pure-number",
                    attrs: {
                      oninput: "value=value.replace(/^(0+)|[^\\d]+/g,'')",
                    },
                    model: {
                      value: _vm.ruleForm.fakeSaleNum,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "fakeSaleNum", $$v)
                      },
                      expression: "ruleForm.fakeSaleNum",
                    },
                  }),
              _vm.typeStr !== "details"
                ? _c("p", [_vm._v("设置后，销量从设置的值递增")])
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "真实销量", prop: "saleNum" } },
            [_c("p", [_vm._v(_vm._s(_vm.ruleForm.saleNum))])]
          ),
          _c(
            "el-form-item",
            { attrs: { label: "状态", prop: "status" } },
            [
              _c(
                "el-radio-group",
                {
                  attrs: { disabled: _vm.typeStr === "details" },
                  model: {
                    value: _vm.ruleForm.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "status", $$v)
                    },
                    expression: "ruleForm.status",
                  },
                },
                _vm._l(_vm.dictionaries.enable_status, function (it) {
                  return _c("el-radio", { attrs: { label: it.dictName } })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "validity-time",
              attrs: { label: "有效期", prop: "validityTime" },
            },
            [
              _vm.typeStr === "details"
                ? _vm._l(_vm.ruleForm.validityTime, function (it) {
                    return _c("span", [_vm._v(_vm._s(it))])
                  })
                : _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "picker-options": _vm.pickerOptions,
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      format: "yyyy-MM-dd HH:mm:ss",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      "default-time": ["00:00:00", "23:59:59"],
                    },
                    model: {
                      value: _vm.ruleForm.validityTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "validityTime", $$v)
                      },
                      expression: "ruleForm.validityTime",
                    },
                  }),
            ],
            2
          ),
          _c(
            "el-form-item",
            [
              _vm.rQuery.type === "details"
                ? void 0
                : [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.resetForm("ruleForm")
                          },
                        },
                      },
                      [_vm._v("取消")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", disabled: _vm.submitLoading },
                        on: {
                          click: function ($event) {
                            return _vm.submitForm("ruleForm")
                          },
                        },
                      },
                      [_vm._v("确认")]
                    ),
                  ],
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialog.title,
            visible: _vm.dialog.visible,
            width: _vm.dialog.width,
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
          },
        },
        [
          _c("el-transfer", {
            staticClass: "transfer-gift-form",
            attrs: {
              filterable: "",
              "filter-method": _vm.filterMethod,
              data: _vm.goodsSkuDataList,
              props: { key: "goodsSkuId", label: "goodsSkuName" },
              titles: ["商品列表", "已选列表"],
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ option }) {
                  return _c("div", {}, [
                    _c(
                      "span",
                      {
                        staticClass: "transfer-label",
                        attrs: { title: option.goodsSkuName },
                      },
                      [_vm._v(_vm._s(option.goodsSkuName))]
                    ),
                  ])
                },
              },
            ]),
            model: {
              value: _vm.chooseGoods,
              callback: function ($$v) {
                _vm.chooseGoods = $$v
              },
              expression: "chooseGoods",
            },
          }),
          _c(
            "div",
            { staticClass: "dia-foot-but" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialog.visible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.getGoodsSkuDataList()
                    },
                  },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "添加标签",
            visible: _vm.dialogVisible,
            "append-to-body": "",
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "loglabelbox" }, [
            _c(
              "div",
              { staticClass: "loglabeltopbox" },
              _vm._l(_vm.tagList, function (item, index) {
                return _c(
                  "div",
                  {
                    key: "dd" + item.id,
                    staticClass: "labelitem",
                    class: [item.select ? "selected" : "notselected"],
                    style: { cursor: item.select ? "not-allowed" : "pointer" },
                    on: {
                      click: function ($event) {
                        return _vm.selectTagFn(index)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(item.tagName) + " ")]
                )
              }),
              0
            ),
            _c("div", { staticClass: "circlebox" }, [
              _vm._v(" 已选 "),
              _c("div", { staticClass: "circle" }, [
                _vm._v(" " + _vm._s(_vm.seletedTag.length) + " "),
              ]),
            ]),
            _c(
              "div",
              {
                staticClass: "loglabeltopbox",
                staticStyle: { border: "none" },
              },
              _vm._l(_vm.seletedTag, function (item, index) {
                return _c(
                  "div",
                  { key: "dd" + item.id, staticClass: "labelitem labelitemc" },
                  [
                    _vm._v(" " + _vm._s(item.tagName) + " "),
                    _c("i", {
                      staticClass: "el-icon-circle-close labelicon",
                      on: {
                        click: function ($event) {
                          return _vm.deleteTag(index)
                        },
                      },
                    }),
                  ]
                )
              }),
              0
            ),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }